import { MINIMUM_BROWSER_VERSIONS } from './browser-versions';
import { appInsights } from '../lib/applicationInsights';
import { msalInstance } from './msalInstance';

const API_URL =
  (window.location.origin.includes('azurefd.net') || window.location.origin.includes('volvo.com')
    ? window.location.origin
    : import.meta.env.VITE_API_URL) + '/api';

const MS_GRAPH_V1_URI = 'https://graph.microsoft.com/v1.0';

export const appConfig = {
  apiUrl: API_URL,
  zipName: 'documents.zip',
  appInsights,
  graphSharesEndpoint: `${MS_GRAPH_V1_URI}/shares`,
  environment: import.meta.env.VITE_ENV,
  footerUrl: import.meta.env.VITE_FOOTER_URL,
  footerName: import.meta.env.VITE_FOOTER_NAME,
  meta: {
    title: import.meta.env.VITE_HTML_META_TITLE,
    description: import.meta.env.VITE_HTML_META_DESCRIPTION
  },
  minimumBrowserVersions: MINIMUM_BROWSER_VERSIONS,
  msalInstance
};
